module.exports = __webpack_public_path__ + "img/wechat-qrcode.ac54598f.png";